
import Vue from 'vue';
import Component from 'vue-class-component';
import { Loading } from 'element-ui';

@Component
export default class MainLayout extends Vue {
  loading: boolean = true;
}
